import { isTouchDevice } from '../common/util'
import Swiper, { Navigation, Pagination, A11y } from 'swiper'

Swiper.use([Navigation, Pagination, A11y])

const swipers = []

const fn = {
  init: () => {
    const els = document.querySelectorAll('.icons-slider')
    els.forEach((el) => fn.setupSlider(el))

    if (els.length) {
      window.addEventListener('resize', fn.handleControls)
    }
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper')
    const numSlides = container.querySelectorAll('.swiper-slide').length

    if (numSlides > 1) {
      const swiper = new Swiper(container, {
        slidesPerView: 3,
        spaceBetween: 16,
        speed: 500,
        loop: numSlides >= 6,
        loopedSlides: numSlides,
        allowTouchMove: isTouchDevice,
        navigation: {
          nextEl: el.querySelector('.icons-button-next'),
          prevEl: el.querySelector('.icons-button-prev'),
        },
        pagination: {
          el: el.querySelector('.icons-pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            loopedSlides: numSlides,
            centerInsufficientSlides: true,
            slidesPerView: 6,
          },
        },
        on: {
          afterInit: () => {
            setTimeout(fn.handleControls, 500)
          },
        },
      })

      swiper._container = el
      swipers.push(swiper)
    }
  },

  handleControls: () => {
    swipers.forEach((swiper) => {
      const pagination = swiper._container.querySelector('.icons-pagination')
      const controls = swiper._container.querySelector('.icons-controls')

      let slidesPerView = 3

      if (window.matchMedia('(min-width: 768px)').matches) {
        slidesPerView = 6
      }

      if (swiper.loopedSlides <= slidesPerView || (swiper.isBeginning && swiper.isEnd)) {
        pagination.classList.add('invisible')
        controls.classList.add('invisible')
      } else {
        pagination.classList.remove('invisible')
        controls.classList.remove('invisible')
      }
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
